import { isEqual, isUndefined, omitBy } from 'lodash';
import {
    autorun as mobxAutorun,
    IAutorunOptions,
    IReactionOptions,
    IReactionPublic,
    isObservable,
    reaction,
    toJS,
} from 'mobx';
import { disposeOnUnmount } from 'mobx-react';

function sanitizeObservable(value: any) {
    value = isObservable(value) ? toJS(value) : value;

    if (typeof value == 'object') value = omitBy(value, isUndefined);

    return value;
}

export function mobxEqual(value: any, other: any) {
    const v1 = sanitizeObservable(value);
    const v2 = sanitizeObservable(other);

    return isEqual(v1, v2);
}

export function componentAutorun<T>(
    target: React.Component<any, any>,
    view: (r: IReactionPublic) => any,
    opts?: IAutorunOptions
) {
    return disposeOnUnmount(target, mobxAutorun(view, opts));
}

export function componentReaction<T>(
    target: React.Component<any, any>,
    expression: (r: IReactionPublic) => T,
    effect: (arg: T, r: IReactionPublic) => void,
    opts?: IReactionOptions
) {
    return disposeOnUnmount(target, reaction(expression, effect, opts));
}

export function componentAutoReaction<T>(
    target: React.Component<any, any>,
    expression: (r: IReactionPublic) => T,
    effect: (arg: T, r: IReactionPublic) => void,
    opts?: Omit<IReactionOptions, 'fireImmediately'>
) {
    const reactionOptions: IReactionOptions = opts ?? {};
    reactionOptions.fireImmediately = true;

    return disposeOnUnmount(target, reaction(expression, effect, reactionOptions));
}
